import { NIGHT_TINT } from 'app/constants/AppConstants.js';

export default class Layer extends Phaser.Group {
  constructor({ game, data, inputEnabled = false }) {
    super(game);

    this.data = data;
    this.w = 0;
    this.tr = 0xff;
    this.tg = 0xff;
    this.tb = 0xff;

    this.inputEnableChildren = inputEnabled; // enable input
    let x = 0;
    for (let i = 0; i < data.parts.length; i++) {
      const img = this.game.make.image(x, this.game.height, data.parts[i]);
      img.anchor.set(0, 1);
      x += img.width;
      this.w += img.width;
      this.add(img);
    }
  }

  get width() {
    return this.data.width || this.w;
  }

  setNight(instant) {
    const tint = NIGHT_TINT;
    const r = tint >> 16;
    const g = (tint >> 8) & 0x00ff;
    const b = tint & 0x0000ff;

    if (instant) {
      this.tr = r;
      this.tg = g;
      this.tb = b;
      this.updateTint();
    } else {
      this.game.add
        .tween(this)
        .to({ tr: r, tg: g, tb: b }, 500, null, true)
        .onUpdateCallback(this.updateTint, this);
    }
  }

  setDay() {
    const r = 0xff;
    const g = 0xff;
    const b = 0xff;

    this.game.add
      .tween(this)
      .to({ tr: r, tg: g, tb: b }, 500, null, true)
      .onUpdateCallback(this.updateTint, this);
  }

  updateTint(tween, value, tweenData) {
    tween;
    tweenData;
    value;
    const r = this.tr | 0;
    const g = this.tg | 0;
    const b = this.tb | 0;
    const tint = (r << 16) | (g << 8) | b;

    for (let i = 0; i < this.children.length; i++) {
      this.children[i].tint = tint;
    }
  }

  addSlot(slot) {
    this.add(slot);
  }

  addObject(object) {
    this.addChild(object);
  }
}
